export function filterNullArrays(list) {
    if (!list)
        return [];
    return list.reduce((acc, cur) => (cur ? [...acc, cur] : acc), []);
}
